import "./projects.css";

export const Projects = () => {
  return (
    <section className="projects">
      <h2>Projetos</h2>
      <ul className="projectsCards">
        <li className="card">
          <div className="cardImage">
            <video
              src="./videos/notes-app/notes-app.m4v"
              autoPlay
              loop
              muted
            ></video>
          </div>
          <div className="cardText">
            <h3>Notes App</h3>
            <p>
              Uma aplicação simples para gerenciar anotações de forma fácil e
              intuitiva. Permitindo que usuários possam criar, visualizar,
              editar e excluir anotações de forma fácil e rápida.
            </p>
            <div className="link">
              <a
                href="https://joseph-notes-app.vercel.app/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Visualizar projeto
              </a>
            </div>
          </div>
        </li>
        <li className="card">
          <div className="cardImage">
            <video
              src="./videos/pokedex-react/pokedex-react.m4v"
              autoPlay
              loop
              muted
            ></video>
          </div>
          <div className="cardText">
            <h3>Pokédex</h3>
            <p>
              Pokédex online que permite aos usuários visualizar informações
              detalhadas sobre os Pokémon, como habilidades e tipo, além de
              alternar entre os modos de tema claro e escuro.
            </p>
            <div className="link">
              <a
                href="https://jm-pokedex-react.vercel.app/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Visualizar projeto
              </a>
            </div>
          </div>
        </li>
        <li className="card">
          <div className="cardImage">
            <video
              className="adviceGeneratorApp"
              src="./videos/advice-generator-app/advice-generator-app.m4v"
              autoPlay
              loop
              muted
            ></video>
          </div>
          <div className="cardText">
            <h3>Aplicativo gerador de conselho</h3>
            <p>
              Construído com HTML, CSS e JavaScript, a cada clique no botão uma
              requisição fetch é feita para a api de conselhos, retornando um
              conselho aleatório.
            </p>
            <div className="link">
              <a
                href="https://josephmatheus.github.io/advice-generator-app/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Visualizar projeto
              </a>
            </div>
          </div>
        </li>
        <li className="card">
          <div className="cardImage">
            <video
              src="./videos/multiverse-spiderman/home-page.m4v"
              autoPlay
              loop
              muted
            ></video>
          </div>
          <div className="cardText">
            <h3>Multiverso Homem-Aranha</h3>
            <p>
              Uma página com carrossel animado e os 3 homem-aranha do cinema,
              nas páginas internas as sinopses e trailers de todos os filmes de
              cada um dos heróis.
            </p>
            <div className="link">
              <a
                href="https://spiderman-multiverse-jm.vercel.app/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Visualizar projeto
              </a>
            </div>
          </div>
        </li>
        <li className="card">
          <div className="cardImage">
            <video
              src="./videos/rocketpay/rocketpay.m4v"
              autoPlay
              loop
              muted
            ></video>
          </div>
          <div className="cardText">
            <h3>Rocketpay</h3>
            <p>
              É um componente que simula o preenchimento em tempo real de um
              formulário de cartão de crédito. <br />
              Feito com: HTML, CSS, JS, Vite, IMask
            </p>
            <div className="link">
              <a
                href="https://rocketpay-explorer-lab-jm.vercel.app/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Visualizar projeto
              </a>
            </div>
          </div>
        </li>
        <li className="card">
          <div className="cardImage">
            <video
              src="./videos/to-do-list/to-do-list-project.m4v"
              autoPlay
              loop
              muted
            ></video>
          </div>
          <div className="cardText">
            <h3>Quadro de Tarefas</h3>
            <p>
              Um quadro para adicionar tarefas em sequência, marcar como
              concluída e também excluí-las. Feito com HTML, CSS e JavaScript.
            </p>
            <div className="link">
              <a
                href="https://joseph-todo-list.vercel.app"
                target="_blank"
                rel="noopener noreferrer"
              >
                Visualizar projeto
              </a>
            </div>
          </div>
        </li>
      </ul>
    </section>
  );
};
